import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BreadcrumbEllipsisItem from './BreadcrumbEllipsisItem';
import BreadcrumbItem from './BreadcrumbItem';
import styles from '@dtsl/css-breadcrumb/dist/index.module.css';
const getFormattedItems = (breadcrumbs, maxItems) => {
  const totalItems = breadcrumbs.length;
  let items = [];
  let ellipsisItem = [];
  /**
   * *Important: When maxItems is 3 and breadcrumbs are more then 3 then we need to show first item, ellipsis and last Item
   * *Important: When maxItems is 4 and breadcrumbs are more then 4 then we need to show first item, ellipsis and last 2 Items
   */
  if (totalItems > maxItems) {
    breadcrumbs.forEach((breadcrumb, index) => {
      if (index === 0 || index === totalItems - 2 && maxItems === 4 || index === totalItems - 1) {
        items.push({
          ...breadcrumb,
          index: index
        });
      } else {
        ellipsisItem.push({
          ...breadcrumb,
          index: index
        });
      }
    });
    items = [items[0], {
      ellipsis: true,
      options: ellipsisItem
    }, ...items.slice(1)];
  } else {
    items = breadcrumbs.map((breadcrumb, index) => ({
      ...breadcrumb,
      index: index
    }));
  }
  return items;
};
function Breadcrumb(props) {
  const {
    breadcrumbs = [],
    onSelect = () => {},
    indexSelected = 0,
    maxItems = 3,
    ellipsisAriaLabel = 'show more breadcrumbs'
  } = props;
  const items = useMemo(() => getFormattedItems(breadcrumbs, maxItems), [breadcrumbs, maxItems]);
  return /*#__PURE__*/React.createElement("nav", {
    className: styles['sib-breadcrumb'],
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/React.createElement("ol", {
    className: styles['sib-breadcrumb-list']
  }, items.map((breadcrumb, index) => breadcrumb?.ellipsis ? /*#__PURE__*/React.createElement(BreadcrumbEllipsisItem, {
    key: index,
    breadcrumb: breadcrumb?.options,
    onSelect: onSelect,
    indexSelected: indexSelected,
    ellipsisAriaLabel: ellipsisAriaLabel
  }) : /*#__PURE__*/React.createElement(BreadcrumbItem, {
    key: index,
    breadcrumb: breadcrumb,
    onSelect: onSelect,
    indexSelected: indexSelected,
    isLastItem: index === items.length - 1
  }))));
}
Breadcrumb.propTypes = {
  onSelect: PropTypes.func,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string
  })),
  indexSelected: PropTypes.number,
  maxItems: PropTypes.number,
  ellipsisAriaLabel: PropTypes.string
};
export default Breadcrumb;